import * as React from 'react';

import { CircularProgress } from 'react-md/lib/Progress';
import { ChildCalculationResult } from '../Calculation/types';
import { EstimateWithBreakdown } from './EstimateWithBreakdown';
import { ExplanationText } from './ExplanationText';

interface State {
}

interface Props {
    estimates?: ChildCalculationResult[];
}

export class Estimate extends React.Component<Props & React.HTMLAttributes<HTMLDivElement>, State> {
    public render() {
        if (this.props.estimates) {
            return <div className={this.props.className}>
                <EstimateWithBreakdown childEstimates={this.props.estimates}></EstimateWithBreakdown>
                <ExplanationText>The new subsidy will also apply to Out of School Hours Care and Vacation Care, but these are not covered by this calculator. For more information on what the Child Care Subsidy will mean for Out of School Hours Care and Vacation Care, talk to your centre director.</ExplanationText>
            </div>
        } else {
            return <CircularProgress id="InitialDataLoad" centered={true}></CircularProgress>;
        }
    }
}